"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NFTBaseResources = void 0;
const assets_1 = require("./assets");
const burns_1 = require("./burns");
const collections_1 = require("./collections");
const configurations_1 = require("./configurations");
const transfers_1 = require("./transfers");
exports.NFTBaseResources = {
    assets: assets_1.Assets,
    burns: burns_1.Burns,
    configurations: configurations_1.Configurations,
    transfers: transfers_1.Transfers,
    collections: collections_1.Collections,
};
//# sourceMappingURL=index.js.map